"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelsSpec = exports.RulesSpec = exports.EmailChannelResponse = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const NotificationChannel = __importStar(require("../../../notification-channel"));
const Rule = __importStar(require("../../../rule"));
const Protocol = __importStar(require("../protocol"));
const authorization_1 = require("./authorization");
const Error = __importStar(require("./error"));
const tracing_1 = require("./tracing");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Rules';
const ruleIdParam = platform_1.HttpApiSchema.param('ruleId', Rule.RuleId);
const channelIdParam = platform_1.HttpApiSchema.param('channelId', NotificationChannel.ChannelId);
// S.pick over S.omit: new fields on EmailChannel are excluded from the response by default,
// preventing future internal fields from accidentally leaking to the API surface.
exports.EmailChannelResponse = NotificationChannel.EmailChannel.pipe(effect_1.Schema.pick('id', 'createdAt', 'updatedAt', 'userId', 'type', 'active', 'email', 'name')).annotations({
    identifier: `${exports.NAMESPACE}.EmailChannelResponse`,
    description: 'E-mail notification channel (public view)',
});
const getRules = platform_1.HttpApiEndpoint.get('getRules') ``
    .addSuccess(Protocol.responseBodySuccess(effect_1.Schema.Array(Rule.Rule)))
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Rules')
    .annotate(platform_1.OpenApi.Description, 'List automation rules for the current user');
const createRule = platform_1.HttpApiEndpoint.post('createRule') ``
    .setPayload(Rule.CreateRulePayload)
    .addSuccess(Protocol.responseBodySuccess(Rule.Rule), { status: 201 })
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Create Rule')
    .annotate(platform_1.OpenApi.Description, 'Create a new automation rule');
const updateRule = platform_1.HttpApiEndpoint.put('updateRule') `/${ruleIdParam}`
    .setPayload(Rule.CreateRulePayload)
    .addSuccess(Protocol.responseBodySuccess(Rule.Rule))
    .addError(Error.NotFoundErrorFromProtocol)
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Update Rule')
    .annotate(platform_1.OpenApi.Description, 'Update an existing automation rule');
const deleteRule = platform_1.HttpApiEndpoint.del('deleteRule') `/${ruleIdParam}`
    .addSuccess(platform_1.HttpApiSchema.NoContent)
    .addError(Error.NotFoundErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Delete Rule')
    .annotate(platform_1.OpenApi.Description, 'Delete an automation rule');
const createEmailChannel = platform_1.HttpApiEndpoint.post('createEmailChannel') `/channel/email`
    .setPayload(NotificationChannel.CreateEmailChannelPayload)
    .addSuccess(Protocol.responseBodySuccess(exports.EmailChannelResponse), { status: 201 })
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Create Email Channel')
    .annotate(platform_1.OpenApi.Description, 'Create a new e-mail notification channel');
const updateEmailChannel = platform_1.HttpApiEndpoint.put('updateEmailChannel') `/channel/email/${channelIdParam}`
    .setPayload(NotificationChannel.CreateEmailChannelPayload)
    .addSuccess(Protocol.responseBodySuccess(exports.EmailChannelResponse))
    .addError(Error.NotFoundErrorFromProtocol)
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Update Email Channel')
    .annotate(platform_1.OpenApi.Description, 'Update an existing e-mail notification channel');
const getChannels = platform_1.HttpApiEndpoint.get('getChannels') `/channels`
    .addSuccess(Protocol.responseBodySuccess(effect_1.Schema.Array(exports.EmailChannelResponse)))
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Get Channels')
    .annotate(platform_1.OpenApi.Description, 'List e-mail notification channels for the current user');
const deleteChannel = platform_1.HttpApiEndpoint.del('deleteChannel') `/channels/${channelIdParam}`
    .addSuccess(platform_1.HttpApiSchema.NoContent)
    .addError(Error.NotFoundErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Delete Channel')
    .annotate(platform_1.OpenApi.Description, 'Delete a notification channel');
exports.RulesSpec = platform_1.HttpApiGroup.make('rules')
    .middleware(authorization_1.UserAuthorization)
    .middleware(tracing_1.Tracing)
    .add(getRules)
    .add(createRule)
    .add(updateRule)
    .add(deleteRule)
    .prefix('/rules')
    .annotate(platform_1.OpenApi.Title, 'Rules')
    .annotate(platform_1.OpenApi.Description, 'Automation rules and notification channels');
exports.ChannelsSpec = platform_1.HttpApiGroup.make('notificationChannels')
    .middleware(authorization_1.UserAuthorization)
    .middleware(tracing_1.Tracing)
    .add(createEmailChannel)
    .add(updateEmailChannel)
    .add(getChannels)
    .add(deleteChannel)
    .prefix('/rules/notifications')
    .annotate(platform_1.OpenApi.Title, 'Notification Channels')
    .annotate(platform_1.OpenApi.Description, 'Notification channel management');
//# sourceMappingURL=rules.js.map